// extracted by mini-css-extract-plugin
export var closeButton = "_1s-0";